import Map from 'scripts/models/base/map';
import List from 'scripts/models/base/list'

const Action = Map.extend({
    define: {
        type: {
            type: 'string',
            value: 'link'
        },
        title: {
            type: 'string',
            value: ''
        },
        url: {
            type: 'string',
            value: ''
        },
        target: {
            type: 'string',
            value: 'same'
        }
    }
});

const Image = Map.extend({
    define: {
        id: {
            type: 'string',
            value: ''
        },
        crop: {
            type: 'string',
            value: 'fill'
        },
        gravity: {
            type: 'string',
            value: 'center'
        }
    }
});

export const Card = Map.extend({
    define: {
        title: {
            type: 'string',
            value: ''
        },
        caption: {
            type: 'string',
            value: ''
        },
        image: {
            Type: Image,
            Value: '*'
        },
        action: {
            Type: Action,
            Value: '*'
        }
    }
});

export const Cards = List.extend({Map: Card}, {});
